import * as Yup from 'yup';

const requiredFieldMessage = '${label} is a required field';

export const defaultValidations = ({ canManagePrivate, canManagePublic }) => {
  let nameRequired = Yup.object({
    Name: Yup.string()
      .nullable()
      .label('Name')
      .required(requiredFieldMessage)
      .test('len', '${label} cannot exceed 50 characters', (val) => val?.length <= 50),
  });

  const observationTypeValidation = Yup.object().shape({
    DataGraphs: Yup.array().of(
      Yup.object().shape({
        Name: Yup.string()
          .label('Graph Name')
          .nullable()
          .test('len', '${label} cannot exceed 50 characters', (val) => (val || '').length <= 50),
        PersistentGraphFilters: Yup.array().of(
          Yup.object()
            .shape({
              ObservationTypeId: Yup.number().test(
                'is-negative',
                'Dataset/Observation Type must have a selection',
                (value) => (value || 0) >= 0,
              ),
              // .test('duplicated', 'Dataset/Observation is already selected in Graph', function (value) {
              //   console.log(this.parent);
              //   return true;
              // }),
            })
            .test('is-duplicated', function (value, { createError, path }) {
              //ignore actual weather stations, they are auto grouped
              if (value.WeatherStationId > 0) return true;

              //filter the pgf's to remove those with an actual weather station id
              const filteredPGF = this.parent.filter((p) => p.WeatherStationId < 0);

              //we only checked against deferreds
              return filteredPGF.findIndex((pgf) => {
                return (
                  pgf.ObservationTypeId === value.ObservationTypeId && pgf.WeatherStationId !== value.WeatherStationId
                );
              }) < 0
                ? true
                : createError({
                    message: { ObservationTypeId: 'Dataset/Observation Type is already selected' },
                    path,
                  });
            }),
        ),
      }),
    ),
  });

  const isPublicValidatoin = Yup.object().shape({
    IsPublic: Yup.boolean().test(
      'is-public-preset',
      'Missing permission required to create a private preset',
      function (value) {
        // Check the conditions for allowing the checkbox to be unchecked
        return canManagePrivate || (canManagePublic && value);
      },
    ),
  });

  return nameRequired.concat(observationTypeValidation).concat(isPublicValidatoin);
};
